import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestSite = loadable(() => import(/* webpackChunkName: "content/guest/site" */ './GuestSite'), 'GuestSite');
